import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import { loadReoScript } from 'reodotdev';
import './index.css';
import App from './App';
import faviconSvg from './assets/images/favicon.svg';

// Initialize PostHog on prod and localhost for testing
if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  const isProd = hostname === 'docstrange.nanonets.com' || hostname === 'nanonets.com';
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
  const enableAnalytics = isProd || isLocal;

  if (enableAnalytics) {
    // Primary: PostHog Web US
    posthog.init('phc_VqbxTvldEJ1r1zdaki37GM5QeZxz2FVlrpnEGepQWW9', {
      api_host: 'https://us.i.posthog.com',
      capture_pageview: true,
      persistence: 'localStorage',
      autocapture: true,
      session_recording: { recordCrossOriginIframes: false },
      disable_session_recording: false,
      debug: isLocal,
    });
    window.posthog = posthog;

    // Legacy: events.nanonets.com proxy
    posthog.init('h0AAz0T8UM_liYI4aQREM7VdMDGRLF8B1YbZCeuBUww', {
      api_host: 'https://events.nanonets.com',
      capture_pageview: true,
      persistence: 'localStorage',
      autocapture: true,
      session_recording: { recordCrossOriginIframes: false },
      disable_session_recording: false,
      debug: isLocal,
    }, 'posthog-legacy');
  }

  // Initialize Reo Analytics via NPM
  const reoClientID = 'f5eae70e3bc807a';
  loadReoScript({ clientID: reoClientID })
    .then((Reo) => {
      Reo.init({ clientID: reoClientID });
      window.Reo = Reo;
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('[Reo] Error loading Reo', error);
    });

  // Set favicon from bundled SVG asset
  try {
    const link = document.querySelector("link[rel='icon']") || document.createElement('link');
    link.type = 'image/svg+xml';
    link.rel = 'icon';
    link.href = faviconSvg;
    const head = document.getElementsByTagName('head')[0];
    if (!link.parentNode) head.appendChild(link);
  } catch (_) {}
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
